<template>
    <FormGroupNew label="Test"
                  description="Click the button to test the settings.">
        <button class="btn btn-xs btn-secondary px-5" :disabled="testingConnection" @click="testApi">
            <i class="fas fa-arrow-right"/>
            Test connection
        </button>
        <div v-if="testingConnection" class="text-warning mt-1">
            <div class="spinner spinner-xs spinner-warning d-inline-block mr-5"/>
            Testing connection...
        </div>
        <div v-else-if="connectionSuccessful != null && connectionSuccessful" class="text-success mt-1">
            <i class="fas fa-check-circle"/>
            Connection successful
        </div>
        <div v-else-if="connectionSuccessful != null && !connectionSuccessful" class="text-danger mt-1">
            <i class="fas fa-times-circle"/>
            Connection failed, please check the settings
        </div>
    </FormGroupNew>
</template>

<script>
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew},

    props: {
        configs: Object
    },

    data() {
        return {
            testingConnection: false,
            connectionSuccessful: null,
        }
    },

    methods: {
        testApi() {
            this.testingConnection = true;

            axios.post(this.$route('integrations.GSYS.test'), {
                host: this.configs.api_url,
                user: this.configs.api_user,
                password: this.configs.api_pw,
            }).then(response => {
                this.connectionSuccessful = response.data.success;
                this.testingConnection = false;
            }).catch(errorResponse => {
                this.connectionSuccessful = false;
                this.testingConnection = false;
            })
        }
    }
}
</script>
